import { useState, useEffect } from 'react'
import './ResultItem.css'

const ResultItem = ({
  question_title,
  option_a,
  option_b,
  option_c,
  option_d,
  answer,
  chosen_option,
}) => {
  const [optionState, setOptionState] = useState({
    option_a: '',
    option_b: '',
    option_c: '',
    option_d: '',
  })

  const validate = (option) => {
    if (chosen_option === option) {
      setOptionState((prev) => ({ ...prev, [chosen_option]: 'incorrect' }))
    }
    if (option === answer) {
      setOptionState((prev) => ({ ...prev, [option]: 'correct' }))
    }
  }

  useEffect(() => {
    validate('option_a')
    validate('option_b')
    validate('option_c')
    validate('option_d')
  }, [])

  return (
    <div className='quiz-result__content__body'>
      <div className='quiz-result__content__question'>
        <h3>{question_title}</h3>
      </div>
      <div className='quiz__content__question-bank'>
        <div className={`quiz-result__content__option ${optionState.option_a}`}>
          <p>{option_a}</p>
        </div>
        <div className={`quiz-result__content__option ${optionState.option_b}`}>
          <p>{option_b}</p>
        </div>
        <div className={`quiz-result__content__option ${optionState.option_c}`}>
          <p>{option_c}</p>
        </div>
        <div className={`quiz-result__content__option ${optionState.option_d}`}>
          <p>{option_d}</p>
        </div>
      </div>
    </div>
  )
}

export default ResultItem
